// extracted by mini-css-extract-plugin
module.exports = {"activityLog":"styles_activityLog___3mxf","infoText":"styles_infoText__yGysN"};